import axios from "axios";
import { API_URL } from "../../config";
import { getToken } from "../../utils/authManager";

export const _uploadMedia = (file) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}media/`, file,{
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

